import { Params, ParamMap } from '@angular/router';
import { InvoiceStatuses } from 'src/shared/api';

export const INVOICE_STATUSES_KEY = 'invoice-statuses';

export const toInvoiceStatusesParams = (args: {
	invoiceStatuses?: string[];
}): Params => ({
	[INVOICE_STATUSES_KEY]: args.invoiceStatuses
		? args.invoiceStatuses
		: undefined,
});

export const toInvoiceStatusesListArgs = (
	paramMap: ParamMap
): { invoiceStatuses?: InvoiceStatuses[] } =>
	paramMap.has(INVOICE_STATUSES_KEY)
		? {
				invoiceStatuses: paramMap.getAll(
					INVOICE_STATUSES_KEY
				) as InvoiceStatuses[],
		  }
		: undefined;
